import 'main.css';
import ProductList from "./components/ProductList";
import ProductDetails from "./components/ProductDetails";

const $=window.jQuery;

const main = async () => {

    const lang = document.documentElement.lang;

    console.log(' >>> Initializing Addons Module lang=', lang);

    let enableDebug=false;
    if (/[?&]debug=/.test(location.search)) {
        enableDebug=true;
    }

    if (!window['roProductsConfig'] || typeof window['roProductsConfig']!=="object") {
        console.error('roProductsConfig not found, skipping code execution');
        return;
    }
    const config = window['roProductsConfig'];

    const cssCode = config.css;
    if (!cssCode) {
        console.info('CSS not set, skipping css inject');
    } else {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = cssCode;
        document.getElementsByTagName('head')[0].appendChild(style);
    }

    if (!$) {
        console.error('Can not run addons module without a valid jQuery object');
        return;
    }

    const run = () => {
        const productList = $('.ProductList__content');
        console.log(productList);
        const productDetail = $('.ProductDetails__information');
        console.log(productDetail);

        let currentModule;

        if (productList.length>0) {
            currentModule = new ProductList(lang, enableDebug);
        } else if (productDetail.length>0) {
            currentModule = new ProductDetails(lang, enableDebug);
        }

        if (!currentModule) {
            console.log(' >>> Addons Module: Could not determine current module, waiting some more');
            setTimeout(run, 500);
        } else {
            console.log(' >>> Addons Module: Running current module: ', currentModule);

            currentModule.run();
        }

    }

    if (document.readyState === "complete" || document.readyState === "loaded") {
        console.log(' >>> Addons Module: Running now');
        setTimeout(run, 500);
    } else {
        console.log(' >>> Addons Module: Waiting for page to load');
        document.addEventListener("DOMContentLoaded",()=>{
            setTimeout(run, 500);
        });
    }
    return true;
}

main().then(() => console.log('>>> Addons Module Started'));
